// crewbit-admin/src/pages/Money/Settings/People.tsx
//
// /money/settings/people — People sub-screen.

import { useEffect } from 'react';
import { PageHeader } from '../../../components/common/PageHeader';
import PeoplePanel from '../../../components/money/settings/PeoplePanel';
import { admin, spacing } from '../../../styles/tokens';

const pageStyle: React.CSSProperties = {
  padding: spacing.xl,
  background: admin.bg,
  minHeight: '100vh',
};

export function MoneySettingsPeople() {
  useEffect(() => {
    document.title = 'CrewBit · People settings';
  }, []);

  return (
    <div style={pageStyle}>
      <PageHeader
        title="People"
        description="Accountant invites and team money permissions."
        back={{ to: '/money/settings', label: 'Money settings' }}
      />
      <PeoplePanel />
    </div>
  );
}
